import { Popover } from 'antd';
import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';

type PopoverAppProps = {
  children: React.ReactNode;
  isOpen: boolean;
  title: React.ReactNode;
  content: React.ReactNode;
};

const PopoverApp: React.FC<PopoverAppProps> = ({ children = '<CHILDREN>', isOpen = false, title = '<TITLE>', content = '<CONTENT>' }) => {
  const [openState, setOpenState] = useState<boolean>(isOpen);

  useEffect(() => {
    setOpenState(isOpen);
  }, [isOpen]);

  return (
    <div className={styles['popover-app']}>
      <Popover content={content} title={title} trigger='click' open={openState} onOpenChange={setOpenState}>
        {children}
      </Popover>
    </div>
  );
};

export default PopoverApp;
